import { useParams } from 'react-router';
import { Box, InlineMessage, ProgressCircle } from '@bigcommerce/big-design';
import CustomerInfo from './components/CustomerInfo';
import Header from './components/Header';
import History from './components/History';
import LineItems from './components/LineItems';
import Photos from './components/Photos';
import PreviousOrders from './components/PreviousOrders';
import { useOrderEditState } from './hooks/useOrderEditState';
import { useScrollToPhotos } from './hooks/useScrollToPhotos';
import './OrdersEditorPage.css';

export function OrdersEditorPage() {
	const params = useParams();

	const [photosRef, executeScroll] = useScrollToPhotos();
	const [orderState, dispatch] = useOrderEditState(params.id);

	return (
		<>
			<Header
				orderState={orderState}
				onPhotosNavigate={executeScroll}
				orderDispatch={dispatch}
			/>
			{(() => {
				if (orderState.isLoading) {
					return (
						<div style={{ textAlign: 'center' }}>
							<ProgressCircle size="large" />
						</div>
					);
				}

				if (Object.entries(orderState.order).length === 0) {
					return (
						<InlineMessage
							type="info"
							messages={[{ text: 'Order not found.' }]}
							marginVertical="medium"
						/>
					);
				}

				return (
					<Box style={{ maxWidth: '2180px', margin: '0 auto' }}>
						<CustomerInfo
							orderDispatch={dispatch}
							order={orderState.order}
							custom={orderState.custom}
							prevOrders={orderState.custom.prevOrders}
						/>
						<LineItems
							orderDispatch={dispatch}
							custom={orderState.custom}
							order={orderState.order}
						/>
						<PreviousOrders orders={orderState.custom.prevOrders} />
						<Photos
							photos={orderState.custom.photos}
							photosRef={photosRef}
							orderDispatch={dispatch}
							customerMessage={orderState.order.customer_message}
						/>
						<History
							logs={orderState.custom.logs}
							orderDispatch={dispatch}
						/>
					</Box>
				);
			})()}
		</>
	);
}
